<script setup>

import { Switch } from '@headlessui/vue'
import { defineModel } from 'vue'

const props = defineProps({
	disabled: { type: Boolean, default: false },
	screen_reader_text: { type: String, required: true },
	bg_enabled_off: { type: String, required: false, default: 'bg-primary-darkest' },
	bg_enabled_on: { type: String, required: false, default: 'bg-primary' },
	bg_disabled: { type: String, required: false, default: 'bg-disabled' },
	size: { type: String, required: false, default: 'normal' },
})

const model = defineModel( { required: true, type: Boolean, default: false } )

function getClass()
{
	let css = [];

	switch(props.size)
	{
		case 'tiny':
			css.push("h-4")
			css.push("w-8")
			break;

		case 'small':
			css.push("h-5")
			css.push("w-10")
			break;
		case 'normal':
			css.push("h-6")
			css.push("w-13")
			break;
	}

	if (props.disabled)
	{
		css.push(props.bg_disabled)
	}
	else
	{
		css.push(model.value ? props.bg_enabled_on : props.bg_enabled_off)
		css.push("cursor-pointer")
		css.push("focus:ring focus:ring-information-pressed")
		css.push("hover:ring hover:ring-information-pressed")
	}
	return css.join(" ");
}

/**
 * Gets the css to set the size of the white dot
 * @returns {string}
 */
function getSwitchCss()
{
	let css = [];
	switch(props.size)
	{
		case 'tiny':
			css.push("h-3")
			css.push("w-3")
			break;

		case 'small':
			css.push("h-4")
			css.push("w-4")
			break;
		case 'normal':
			css.push("h-5")
			css.push("w-5")
			break;
	}

	return css.join(" ");
}

function getTranslate()
{
	switch(props.size)
	{
		case 'tiny':
			return 'translate-x-4'

		case 'small':
			return 'translate-x-5'

		case 'normal':
			return 'translate-x-7'
	}
}

</script>

<template>
	<Switch
		v-model="model"
		:class="getClass()"
		:disabled="disabled"
		class="relative w-10 inline-flex shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out"
	>
		<span class="sr-only">{{ screen_reader_text }}</span>
		<span
			aria-hidden="true"
			:class="[model ? getTranslate() : 'translate-x-0', getSwitchCss() ]"
			class="pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out"
		/>
	</Switch>
</template>

<style scoped>

</style>